import React from 'react';
import { cn } from '@/utils/classNames';

interface ErrorStateProps {
  message?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  className?: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  message = 'An error occurred',
  buttonText = 'Go back',
  onButtonClick,
  className,
}) => {
  return (
    <div className={cn('min-h-screen flex items-center justify-center', className)}>
      <div className="text-center">
        <p className="text-gray-600">
          {message}
        </p>
        {onButtonClick && (
          <button
            onClick={onButtonClick}
            className="mt-4 bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors"
          >
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorState; 